<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>欠損承認</h1>
<mat-card-content>
    <div *ngIf="cmpnyAreaInit && cndtAuthorityList?.length > 0 &&codeConversionMstMap?.size > 0">
        <form (ngSubmit)="onClickSearch()" [formGroup]="sgke411aRequestForm">
            <!-- 検索条件コンポーネント -->
            <app-sgke410d-condition [codeConversionMstMap]="codeConversionMstMap" [cmpnyAreaList]="cmpnyAreaList"
                [cmpnyAreaInit]="cmpnyAreaInit" [cndtAuthorityList]="cndtAuthorityList"
                (onClickSearchEvent)="onClickSearch()" (onClickClearEvent)="onClickClear()">
            </app-sgke410d-condition>
        </form>
    </div>
</mat-card-content>
<!-- 検索結果コンポーネント -->
<app-sgke410d-result *ngIf="searchresultList?.length > 0" [searchresultList]="searchresultList"
    (onClickApprovalEvent)="onClickApproval($event)" (onClickOutputEvent)="onClickOutput($event)">
</app-sgke410d-result>